import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { checkSlowMode } from 'APP/Tasks/messaging/checkSlowMode/checkSlowMode';
import Entities from 'STORE';

export const useDraftHeaderPresenter = ({ core }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const source = useAsObservableSource({ core });

  const presenter = useLocalStore(() => ({
    async onCloseDraft() {
      Tasks.app.showConfirm({
        title: t('channel_article_save_changes'),
        text: t('channel_article_save_changes_info'),
        primaryText: t('common_save'),
        secondaryText: t('common_discard'),
        async onSuccess() {
          await source.core.handleUpdateDraft();
          presenter.goBack();
          Entities.toast.show(t('common_changes_saved'));
        },
        onCancel() {
          presenter.goBack();
        },
      });
    },

    deleteDraft: async () => {
      const canDelete = await Tasks.app.showConfirm({
        text: t('delete_message'),
        primaryText: t('common_yes'),
        secondaryText: t('common_cancel'),
      });

      if (canDelete) {
        const res = await Tasks.drafts.deleteDraft(source.core.draft);
        if (res) {
          presenter.goBack();
        }
      }
    },

    goBack: () => {
      navigate(-1);
    },

    onClick: () => {
      const canSend = checkSlowMode();
      if (!canSend.result) {
        canSend.error && Tasks.app.showToast(canSend.error);
        return;
      }
      source.core.handleCreateArticle();
      navigate(source.core.group.routePath, { replace: true });
    },
  }));

  return presenter;
};
